// extracted by mini-css-extract-plugin
module.exports = {"root":"TabBar_root__z0Gxw","button":"TabBar_button__r6qqT","active":"TabBar_active__2yF6k","dark":"TabBar_dark__jjolz","light":"TabBar_light__cSR3t"};